/* ==========================================================================
   BuildDirect — Cart drawer
   --------------------------------------------------------------------------
   Two jobs, both of them about the same problem: the cart holds two different
   purchases and behaves as though it holds one.

   1. Keep the drawer's kind current. snippets/cart-items.liquid publishes the
      cart's kind on a token inside <cart-items>, which every AJAX path
      re-renders. The <cart-drawer> element's own attributes are not rewritten
      when a line changes (assets/cart-items.js replaces the innerHTML of
      cart-items, #cart-promoted-products and .cart-drawer__summary — not the
      drawer's attributes), so data-cart-mode up there would go stale the moment
      a mixed cart lost its last product. This mirrors the token onto the drawer
      so CSS and analytics read one source of truth.

   2. Split sample traffic from purchase traffic. docs/site-audit-2026-08.md C7:
      GA4 counts a $0.00 sample request and a pallet of engineered hardwood as
      the same add_to_cart, which makes every cart metric in the audit — the
      halved cart-add rate included — a blend of two behaviours with different
      economics. Sample and product carts can't be optimised separately until
      they can be told apart, so every event here carries cart_mode.

   Events pushed to dataLayer (GTM-TWC9KZRX is already installed, so events are
   dataLayer pushes — docs/landing-page-system.md):

   | Event                | Fires on                                        |
   |----------------------|-------------------------------------------------|
   | cart_drawer_view     | Drawer opens (any path — icon, add, sample CTA)  |
   | cart_checkout_click  | Checkout button in the drawer                    |

   Both carry cart_mode, cart_sample_lines, cart_product_lines, cart_item_count
   and cart_value_cents. Deliberately not named begin_checkout: GA4 reserves
   that for the checkout step itself and the store already reports it.
   ========================================================================== */

(function () {
  if (window.__bdCartDrawerInit) return;
  window.__bdCartDrawerInit = true;

  var DRAWER_ID = 'cart-drawer';

  function drawer() {
    return document.getElementById(DRAWER_ID);
  }

  /* The token rendered by snippets/cart-items.liquid. Scoped to the drawer so
     the cart page's own <cart-items> can never be read instead. */
  function token() {
    var el = drawer();
    return el ? el.querySelector('[data-bd-cart-mode]') : null;
  }

  function int(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function state() {
    var el = token();
    if (!el) return { cart_mode: 'empty', cart_sample_lines: 0, cart_product_lines: 0, cart_item_count: 0, cart_value_cents: 0 };

    return {
      cart_mode: el.getAttribute('data-bd-cart-mode') || 'empty',
      cart_sample_lines: int(el.getAttribute('data-bd-cart-samples')),
      cart_product_lines: int(el.getAttribute('data-bd-cart-products')),
      cart_item_count: int(el.getAttribute('data-bd-cart-count')),
      cart_value_cents: int(el.getAttribute('data-bd-cart-value'))
    };
  }

  function push(event, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: event };
    var current = state();
    for (var k in current) if (Object.prototype.hasOwnProperty.call(current, k)) data[k] = current[k];
    for (var j in payload || {}) if (Object.prototype.hasOwnProperty.call(payload, j)) data[j] = payload[j];
    window.dataLayer.push(data);
  }

  /* ------------------------------------------------------------- mode sync */

  function syncMode() {
    var el = drawer();
    if (!el) return;

    var mode = state().cart_mode;
    if (el.getAttribute('data-cart-mode') !== mode) {
      el.setAttribute('data-cart-mode', mode);
    }
  }

  /* ------------------------------------------------------------------ view */

  /* The drawer opens from the cart icon, from an add-to-cart, and from the
     sample buttons' dispatch:cart-drawer:open — watching the attribute the
     theme's own drawer sets catches all three without knowing about any of
     them, and without firing on a re-render that leaves the drawer closed. */
  function watchOpenState() {
    var el = drawer();
    if (!el) return;

    var wasOpen = el.hasAttribute('open');

    new MutationObserver(function () {
      var isOpen = el.hasAttribute('open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) push('cart_drawer_view');
    }).observe(el, { attributes: true, attributeFilter: ['open'] });

    /* Re-renders replace the token, so re-read it rather than caching. */
    new MutationObserver(syncMode).observe(el, { childList: true, subtree: true });
  }

  /* -------------------------------------------------------------- checkout */

  /* Delegated from the document: the button lives inside
     .cart-drawer__summary, which is replaced wholesale on every line change,
     so a listener bound to the button itself would survive exactly one edit. */
  document.addEventListener('click', function (evt) {
    if (!evt.target || typeof evt.target.closest !== 'function') return;
    var btn = evt.target.closest('[name="checkout"][data-bd-cart-mode]');
    if (!btn) return;
    push('cart_checkout_click');
  });

  function init() {
    syncMode();
    watchOpenState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
